var r=function(r,t){return"".concat((r/t).toFixed(2),"rem")};export{r as p};
//# sourceMappingURL=index-b259367e.js.map
